/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
/**
 * Created by leo on 19.10.17.
 */

export const statDimension = (dimensionName, value) => {
    if(value)
    {
        let obj = {}
        obj[dimensionName] = value
        if (window.ga) {
            window.ga('set', obj)
        }
    }
}

export const statDimensionMatch = (dimensionName, url, matcher) => {
    const matchValue = url.match(matcher)
    if(matchValue)
    {
        const value = matchValue[1]
        statDimension(dimensionName, value)
    }
}

/*
export const countPageView = (url, extras) => {
    return new Promise((resolve, reject) => {
        let body = JSON.stringify({clip_id: url, action: 'count', extras: extras})
        fetch(`https://lapi.traceup.com/tracebot-${process.env.REACT_APP_TRACE_ENV}/tracebot/clips/views`, {
            method: 'POST',
            mode: 'cors', // no-cors, cors, *same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                'Content-Type': 'application/json'
            },
            body: body
        })
            .then(response => {
                return response.json()
            })
            .then(json => {
                resolve(json)
            })
            .catch(e => {
                console.error('countPageView error', e)
                resolve(null)
            })
    })
}
*/

export const getPageViews = (clipIds) => {
    return new Promise((resolve, reject) => {

        let body = JSON.stringify({
            game_clip_ids: clipIds,
        })
        //let url = 'http://localhost:3000/dev/tracebot/views?action=list'
        let url = `https://lapi.traceup.com/tracebot-${process.env.REACT_APP_TRACE_ENV}/tracebot/views?action=list`

        fetch(url, {
            method: 'POST',
            mode: 'cors', // no-cors, cors, *same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                'Content-Type': 'application/json'
            },
            body: body
        })
            .then(response => {
                return response.json()
            })
            .then(json => {
                resolve(json.data.count)
            })
            .catch(e => {
                resolve(0)
            })
    })
}


export const STAT_DIM_GAME_ID = 'dimension3'
export const STAT_DIM_PLAYLIST = 'dimension4'
export const STAT_DIM_CLIP_NUM = 'dimension2'
export const STAT_DIM_PANEL = 'dimension1'
export const STAT_DIM_ACTION = 'dimension6'

export const EXTRACT_GAME_ID = 'games/(.*?)/'
export const EXTRACT_CLIP_NUM = 'notes/([0-9]+)'
export const EXTRACT_PLAYLIST = 'playlists/(.*?)(-[0-9]+-[a-z]+)*/'
export const EXTRACT_PANEL = 'notes/[0-9]+/([a-z-]+)'

export const statPageView = (url) => {

    if(!url)
    {
        let hashUrl = window.location.hash.replace('#/', '')
        if (hashUrl.includes('/games/')) {
            let hashParts = hashUrl.split('/')
            let tmid = hashParts[0]
            let gmid = hashParts[2]
            hashParts[2] = `${tmid}-${gmid}`
            hashParts.splice(3, 0, 'playlists')
            hashParts.splice(5, 0, 'notes')
            hashUrl = hashParts.join('/')
        }
        url = '#/' + hashUrl
    }

    let m = url.match(/#\/(.*?)\/games\/.*?$/)
    if(m && statStoreState()) {
        let state = statStoreState()
        //do not submit pageviews if we aren't fully loaded...
        if(state.game.value) {
            const gameInfo = state.game.value
            const teamName = toValidString(gameInfo.home_team.name)
            const gameId = teamName + '-' + gameInfo.game_id

            //set game_id
            statDimension(STAT_DIM_GAME_ID, gameId)
            //set playlistName
            statDimensionMatch(STAT_DIM_PLAYLIST, url, EXTRACT_PLAYLIST)
            //set clip number
            statDimensionMatch(STAT_DIM_CLIP_NUM, url, EXTRACT_CLIP_NUM)
            //set panel name
            statDimensionMatch(STAT_DIM_PANEL, url, EXTRACT_PANEL)

            if (window.ga) {
                window.ga('send', { hitType: 'pageview', page: url})
            }
        }
    }
    else
    {
        if (window.ga) {
            window.ga('send', { hitType: 'pageview', page: url})
        }
    }
    return null
}

export const statAdminPageView = (url) => {
    if(!url)
    {
        url = window.location.hash
    }

    let m = url.match(/#(.*?)\/division\/(.*?)\/(.*)$/)
    if(m && statStoreState()) {
        let state = statStoreState()
        let event = {type:'page', group: 'admin', divisionId: m[2], before: m[1], after:m[3]}
        statQueuePush(event)
        if(state.divisions) {
            statPumpAdmin(state.divisions.divisions)
        }
    } else
    {
        if (window.ga) {
            window.ga('send', { hitType: 'pageview', page: url})
        }
    }
}

export const statExtractClipNumber = (url) => {
    const matchValue = url.match(EXTRACT_CLIP_NUM)
    if(matchValue)
    {
        return matchValue[1]
    }
    return null
}

export const statSimplifyClipStats = (json) => {
    if(!json || !json.reports) return { rows: {}, min: 0, max: 0 }

    let rows = json.reports[0].data.rows
    let simpleRows = {}
    for (var i in rows) {
        let cn = statExtractClipNumber(rows[i].dimensions[0])
        if (!simpleRows[cn]) {
            simpleRows[cn] = {numViews: Number(rows[i].metrics[0].values[0])}
        } else {
            simpleRows[cn].numViews += Number(rows[i].metrics[0].values[0])
        }
    }

    var max = 0
    var min = 0
    if (json.reports && json.reports.length > 0) {
        var report = json.reports[0]
        if (report.data && report.data.maximums && report.data.maximums.length > 0) {
            var maxs = report.data.maximums[0]
            if (maxs.values && maxs.values.length > 0) {
                max = maxs.values[0]
            }
        }
        if (report.data && report.data.mimimums && report.data.minimums.length > 0) {
            var mins = report.data.minimums[0]
            if (mins.values && mins.values.length > 0) {
                min = mins.values[0]
            }
        }
    }


    return {
        rows: simpleRows,
        max: Number(max),
        min: Number(min)
    }
}

export const statEvent = (category, label, action, value=1) => {
    if (window.ga) {
        window.ga('send', {
            hitType: 'event',
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: value
        })
    }
}

export const statGameEvent = (origTeamId, origGameId, action, value=1) => {
    if (statStoreState()) {
        let state = statStoreState()
        //do not submit pageviews if we aren't fully loaded...
        if(state && state.game && state.game.value && state.game.value.home_team) {
            const gameInfo = state.game.value
            let teamName = toValidString(gameInfo.home_team.name)
            const gameId = teamName + gameInfo.game_id_hash.substring(gameInfo.team_id.length)
            if(origTeamId !== gameInfo.home_team.id) teamName = origTeamId
            if (window.ga) {
                let params = {
                    hitType: 'event',
                    eventCategory: teamName,
                    eventAction: action,
                    eventLabel: gameId,
                    eventValue: value
                }
                window.ga('send', params)
            }
        }
    }
}

export const statAdminEvent = (divisionId, action, label='unset', value=1) => {
    let event = {type: 'event', group: 'admin', divisionId: ''+divisionId, action: action, label: label, value: value}
    statQueuePush(event)

    if (statStoreState()) {
        let state = statStoreState()
        //do not submit pageviews if we aren't fully loaded...
        if(state.divisions) {
            statPumpAdmin(state.divisions.divisions)
        }
    }
}

const sendAdminEvent = (divisions, event) => {
    let division = event.divisionId === '0' ? divisions[0] :
        divisions.find((item) => '' + item.division_id === event.divisionId)
    let divName = toValidString(division ? division.title : 'no-division')
    event.division = divName
    let url
    if (window.ga) {
        switch(event.type)
        {
        case 'event':
            window.ga('send', {
                hitType: 'event',
                eventCategory: divName,
                eventAction: event.action,
                eventLabel: event.label,
                eventValue: event.value
            })
            break
        case 'page':
            url = `#${event.before}/division/${divName}/${event.after}`
            window.ga('send', { hitType: 'pageview', page: url})
            break
        default:
            break
        }
    }

}

const statQueuePush = (event) => {
    window.analyticsData.queue.push(event)
}

export const statPumpAdmin = (divisions) => {
    if(divisions && divisions.length > 0) {
        window.analyticsData.queue.forEach(item => sendAdminEvent(divisions, item))
        window.analyticsData.queue = []
    }
}

export const statInit = (reduxStore) => {
    window.analyticsData = { queue: [], store: reduxStore }
}

const statStoreState = () => {
    if(window.analyticsData && window.analyticsData.store)
    {
        return window.analyticsData.store.getState()
    }
    return null
}

export const encodedGameId = (gameInfo) => {
    if (gameInfo.home_team == null || gameInfo.game_id == null || gameInfo.team_id == null) {
        return 'no-game-id'
    }
    let teamName = toValidString(gameInfo.home_team.name)
    const encGameId = teamName + gameInfo.game_id.substring(gameInfo.team_id.length)
    return encGameId
}

const validChars = 'abcdefghijklmnopqrstuvwxyz0123456789_-ABCDEFGHIJKLMNOPQRSTUVWXYZ'
const toValidString = (str) => {
    let outstr = ''
    for(let i = 0;i<str.length;i++) {
        let ch = str.charAt(i)
        if(validChars.includes(ch)) outstr += ch
        else outstr += '_'
    }
    return outstr
}
